import { useState, useEffect } from "react"
import { useUpdateTodoMutation, useDeleteTodoMutation } from "./todoApiSlice"

import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan, faFilePen } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'



const EditToDoForm = (todo) => {

	const [updateTodo, {
		isLoading,
		isSuccess,
		isError,
		error
	}] = useUpdateTodoMutation()

	const [deleteToDo, {
		isSuccess: isDelSuccess,
		isError: isDelError,
		error: delerror
	}] = useDeleteTodoMutation()

	const navigate = useNavigate()

	const [completed, setCompleted] = useState(todo.todo.completed)
	const [title, setTitle] = useState(todo.todo.title)
	const due_date = todo.todo.duedate;
	const [duedate, setDuedate] = useState(due_date)
	const [id] = useState(todo.todo.id)
	const [user] = useState(todo.todo.user)

	useEffect(() => {

		if (isSuccess) {
			setTitle('')
			setDuedate('')
			setCompleted('')
			toast.success("ToDo was Updated");
			navigate('/dash/todos')
		}

		if (isDelSuccess) {
			setTitle('')
			setDuedate('')
			setCompleted('')
			toast.success("Todo was Deleted");
			navigate('/dash/todos')
		}

		if (isError) {
			toast.error(error?.data?.message);
		}

		if (isDelError) {
			toast.error(delerror?.data?.message);
		}

	}, [isSuccess, isDelSuccess, isError, isDelError, error, delerror, navigate])


	const onCompletedChanged = () => {
		setCompleted(prev => !prev)
	}
	const onTitleChanged = e => setTitle(e.target.value)
	const onDuedateChanged = e => setDuedate(e.target.value)

	const canSave = [title, duedate].every(Boolean) && !isLoading
	const onSaveToDoClicked = async (e) => {
		if (canSave) {
			await updateTodo({ id, user, title, duedate, completed })
		}
	}

	const onDeleteTodoClicked = async () => {
		await deleteToDo({ id })
	}



	const content = (
		<section id="main_content">
			<header>
				<h1 className="text-steel mt-5"><FontAwesomeIcon icon={faFilePen} style={{ fontSize: "30px", marginRight: "5px" }} />Edit ToDo</h1>
			</header>
			<main>
                <form onSubmit={e => e.preventDefault()}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="title">
                                ToDo:</label>
                            <input
                                className="form-control"
                                id="title"
                                name="title"
                                type="text"
                                autoComplete="off"
                                value={title}
                                onChange={onTitleChanged}
                            />
						</div>
					</div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="duedate">
                                Due Date:</label>
							<input 
								type="date" 
								id="duedate" 
								name="duedate" 
								className="form-control" 
								value={duedate} 
								onChange={onDuedateChanged} 
							/>
						</div>
					</div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="completed">
                                Completed:</label>
							<input 
								type="checkbox" 
								id="completed" 
								name="completed" 
								className="table-input" 
								checked={completed} 
								onChange={onCompletedChanged}
							/>
						</div>
					</div>

                    <div className="row mb-3">
                        <div className="col-md-6 text-end">
							<span
								role="button"
								className="p-2 text-success icon"
								title="Update"
								onClick={onSaveToDoClicked}
							>
								Update
								<FontAwesomeIcon icon={faSave} className="fa-icon mt-1" />
							</span>
							<span
								role="button"
								className="p-2 text-danger icon"
								title="Delete"
								onClick={onDeleteTodoClicked}
							>
								Delete
								<FontAwesomeIcon icon={faTrashCan} className="fa-icon mt-1" />
							</span>
						</div>
					</div>

				</form>

			</main>
		</section>
	)

    return content


}

export default EditToDoForm